import { toast } from 'sonner';

import { optedOutErrorMessage } from './opted-out';

/** Toast the opted-out message when `error` is that refusal. True when it
 *  was, so the caller skips its generic error. */
export function toastIfOptedOut(error: unknown): boolean {
  const message = optedOutErrorMessage(error);
  if (!message) return false;
  toast.info(message);
  return true;
}
